var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentCityCode!==null)?_c('CityMap'):_c('ChinaMap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }